/**
 * Page-level notices: the timezone and consent banners, plus the settings
 * toggle that mirrors the consent choice.
 *
 * Markup contract: `timezone_banner` root looks for
 * `input[data-tz-detected]` to mirror the detected zone onto the
 * "Use detected" form.
 */
import { consent } from "./helpers.js";

document.addEventListener("alpine:init", () => {
  Alpine.data("analytics_toggle", () => ({
    enabled: false,
    init() {
      this.enabled = consent.is_accepted();
    },
    toggle() {
      this.enabled = !this.enabled;
      if (this.enabled) consent.accept();
      else consent.decline();
    },
  }));

  // One-time IANA-timezone confirmation banner. Hides itself unless the
  // browser-detected TZ differs from UTC; the server-side render already
  // gates on `user.timezone == "UTC" && user.timezone_confirmed_at is none`,
  // so the only remaining check is whether the browser actually has a
  // non-UTC TZ to offer.
  Alpine.data("timezone_banner", () => ({
    visible: false,
    detected: "UTC",
    init() {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
        if (tz && tz !== "UTC") {
          this.detected = tz;
          this.visible = true;
          // Mirror the detected value onto the "Use detected" form's hidden
          // input. The "Keep UTC" button keeps its literal `UTC` value.
          const input = this.$el.querySelector("input[data-tz-detected]");
          if (input) input.value = tz;
        }
      } catch (_e) {
        /* ignore */
      }
    },
    dismiss() {
      this.visible = false;
    },
  }));

  Alpine.data("consent_banner", () => ({
    visible: false,
    init() {
      if (!consent.is_decided()) {
        this.visible = true;
      } else if (consent.is_accepted() && window.posthog) {
        // Re-arm capture on every page load; PostHog starts opted-out.
        window.posthog.opt_in_capturing();
      }
    },
    accept() {
      consent.accept();
      this.visible = false;
    },
    decline() {
      consent.decline();
      this.visible = false;
    },
  }));
});
